import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { ObservablesService } from '../../../Services/observables/observables';
import { isEmpty } from 'lodash';

@Component({
	selector: 'radio-button',
	template: `
		<label
			[attr.for]="control.name.split('PolicyData.').join('') + '_' + value"
			class="radio-button-label"
			[ngClass]="{ selected: value === selectedValue, error: Error }"
			(keydown)="toggle($event)"
		>
			<input
				gtm-handler
				[attr.gtm]="control.name"
				events="change"
				handlerType="checkbox"
				[dataVal]="selectedValueTitle"
				[label]="control.name"
				action="RadioButton"
				type="radio"
				role="radio"
				aria-hidden="true"
				[tabIndex]="disabled ? -1 : 0"
				[attr.aria-checked]="value === selectedValue"
				[checked]="value === selectedValue"
				[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
				[attr.id]="control.name.split('PolicyData.').join('') + '_' + value"
				class="radio-button-input"
				[value]="value"
				[attr.name]="control.name"
				[name]="getName()"
				(change)="updateAnswer()"
				[disabled]="disabled"
			/>
			<span class="custom-input"></span>

			<span class="radio-button-title">
				{{ buttonTitle }}
			</span>
		</label>
	`,
	styleUrls: ['./radio-button.component.scss'],
})
export class RadioButtonCompoent implements OnInit {
	@Input() selectedValue: any;
	@Input() value: any;
	@Input() buttonTitle: any;
	@Input() setAnswer: any;
	@Input() context: any;
	@Input() control: any;
	@Input() disabled: any;
	@Input() Name: any;
	@Input() Error: any;
	number: any;
	selectedValueTitle: any;
	@Output() emitParent: EventEmitter<any> = new EventEmitter();
	@Output() setvalue: EventEmitter<any> = new EventEmitter();

	@HostBinding('attr.name')
	name = this.setName();
	_ref: any;
	removeObject() {
		this._ref.destroy();
	}
	constructor(private sanitizer: DomSanitizer, private observablesService: ObservablesService) {}
	setName() {
		setTimeout(() => {
			this.name = this.control.name;
		}, 300);
	}

	ngOnInit() {
		this.number = this.observablesService.RadioButtonNumber++;
	}

	toggle(event) {
		if (event.code === 'Space') {
			if (this.emitParent.observers.length) {
				this.emitParent.emit({ value: this.value });
			} else {
				this.setvalue.emit({ value: this.value });
				this.setAnswer(this.value);
			}
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		}
	}

	updateAnswer() {
		if (this.emitParent.observers.length) {
			this.emitParent.emit({ value: this.value });
		} else {
			this.setvalue.emit({ value: this.value });
		}
		if (this.control.controlType === 'ExistingAccount') {
			return;
		} else {
			const renderRadio = {
				control: this.control,
				context: this.context,
			};
			// this.observablesService.currentRenderComponent.next(renderRadio)
			// this.elementRef.nativeElement.parentElement.remove()
		}

		let valueTitleObj = this.control.options.filter((op) => op.value == this.value);
		if (valueTitleObj) {
			this.selectedValueTitle = valueTitleObj[0].title;
		}
	}

	getName() {
		return !isEmpty(this.control) ? this.control.name : this.value;
	}

	getSubtitle() {
		let subtitle = this.control.subtitle;
		if (subtitle) {
			return subtitle.replace(/<\/?[^>]+(>|$)/g, '');
		}
		return '';
	}
}
